var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.33333 9.88889L5.5 6M4.33333 6H10.5556L12.1111 8.33333M2 13H12.4222C12.8071 13.0001 13.1861 12.9051 13.5254 12.7232C13.8647 12.5414 14.1537 12.2784 14.3667 11.9578L16.7778 8.33333H11.9322C11.5351 8.33386 11.1417 8.41042 10.7733 8.55889L8.00444 9.66333C7.63609 9.8118 7.24271 9.88836 6.84555 9.88889H3.16667L2 13Z",
    stroke: "#EB564F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.9cf919696d5c70035d175c7c44b9bb32.svg";
export { ForwardRef as ReactComponent };